import { queriesPayeeRows } from "@query";
import { WSTableCell } from "@wingspanhq/fe-component-library";
import React from "react";

import { useXWingspanExpansion } from "../../../../shared/hooks/useXWingspanExpansion";
import { selectorSearchRowName } from "../../../../shared/selectors/selectorSearchRowName";

type Props = {
  payeeEngagementId: string | undefined;
};

/**
 * Resolves the employee behind a work log at the point of use.
 *
 * `listWorkLogs` returns no payee join and `searchPayeeRows` only filters one
 * `engagements_id` at a time, so the name is fetched per row
 * rather than pre-aggregated into a map by the page.
 */
export const EmployeeCell: React.FC<Props> = props => {
  const xWingspanExpansion = useXWingspanExpansion();

  const queryPayeeRow = queriesPayeeRows.searchPayeeRows.useQuery(
    {
      filter: {
        engagements_id: {
          eq: props.payeeEngagementId as string
        }
      },
      page: { size: 1 },
      xWingspanAccount: xWingspanExpansion
    },
    { enabled: !!props.payeeEngagementId }
  );

  const payee = queryPayeeRow.data?.data?.[0];

  if (!payee) {
    return <WSTableCell text={queryPayeeRow.isLoading ? "—" : "-"} />;
  }

  return (
    <WSTableCell
      secondaryText={payee.email ?? undefined}
      text={selectorSearchRowName(payee)}
      truncationOptions={{ text: { allowTwoLines: true } }}
    />
  );
};
